import CountryPageRenderer from '../components/CountryPageRenderer';
import cyprusData from '../data/country-pages/cyprus';

export default function CyprusCountryPage() {
  return <CountryPageRenderer data={cyprusData} />;
}
